const richDescriptionPattern =
  /<\/?(?:p|br|strong|em|u|s|ul|ol|li|blockquote|pre|code|hr|h[1-6]|a)(?:\s|\/?>)/i;

export function auctionDescriptionHtml(description: string): string {
  if (!richDescriptionPattern.test(description)) {
    return description
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\r\n|\r|\n/g, "<br>");
  }

  return description;
}
